const Content = ({ children, small = false }) => {
    return (
        small ? (
            <div className="content w-11/12 mx-auto lg:w-10/12 xl:w-full max-w-4xl">
                {children}
            </div>
        ) 
        :
        (
            <div className="content w-11/12 mx-auto lg:w-10/12 xl:w-full max-w-screen">
                {children}
            </div>
        )
    );
};

export default Content;